export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novoUsuario: {
    pt: 'Novo usuário',
    en: 'New user',
    de: 'Neuer Benutzer',
    es: 'Nuevo usuario',
  },
  reportFileName: {
    pt: 'RELATÓRIO-USUÁRIOS-BRENNTAG.xlsx',
    en: 'BRENNTAG-USERS-REPORT.xlsx',
    de: 'BRENNTAG-BENUTZER-BERICHT.xlsx',
    es: 'INFORME-USUARIOS-BRENNTAG.xlsx',
  },
  exportar: {
    pt: 'Exportar',
    en: 'Export',
    de: 'Exportieren',
    es: 'Exportar',
  },
};
